import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import {
  Table
} from "reactstrap";
import API from "api.js";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import checkIcon from "assets/images/images_new/check_circle.svg";
import cancelIcon from "assets/images/images_new/cancel.svg";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
import AcceptCard from "assets/images/images_new/accept-card.svg";
import GoldImg from "assets/images/images_new/gold-icon.svg";
import secureIcon from "assets/images/images_new/lock-icon.svg";
import successIcon from "assets/images/images_new/success-icon.png";
import upgradeImg from "assets/images/images_new/upgrade-icon.png";
import starImg from "assets/images/images_new/star-icon.svg";
import Spinner from "components/Loader/Spinner";
import { useSelector } from "react-redux";


const Transaction = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const userPlan = user?.active_subscription ?? [];

 const fetchTransactions = () => {
    setIsLoading(true);
    API({
      method: "GET",
      url: "transaction",
    }).then((res) => {
      setData(res?.data?.data);
      setIsLoading(false);
    })
      .catch(() => {
        setIsLoading(false);
      });
  };

    useEffect(() => {
    fetchTransactions();
  }, [userPlan.length]);

  const subscriptionTitle = (val) => {

    console.log("asda", val?.subscription?.plan?.duration);
    
 return val.details !== null
      ? val.details.package + " " + (val?.subscription?.plan?.duration ? `(${val?.subscription?.plan?.duration} Month${val.subscription.plan.duration > 1 ? "s" : ""})` : "")
      : val.subscription &&
      val.subscription.plan &&
      val.subscription.plan.title
    
    // return val.details !== null
    //   ? val.details.package
    //   : val.subscription &&
    //   val.subscription.plan &&
    //   val.subscription.plan.title
  }

  const recurringDate = (val) => {
    return (val.subscription?.status === 1 &&
      val.subscription?.is_recurring_plan === 1) ? (
      val.subscription?.expiry_date
    ) : (
      "-"
    );
  }

  const expiryDate = (val) => {
    return val.subscription?.expiry_date ? val.subscription?.expiry_date : "-";
    // return (val.subscription?.status === 1 &&
    //   val.subscription?.is_recurring_plan === 0) ? (
    //   val.subscription?.expiry_date
    // ) : (
    //   "-"
    // );
  }

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '100px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '50px',
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: '50px',
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '20px',
        },
      },
    ],
  };
console.log(userPlan);

  return (
    <>
      <div className="content p-0 w-100">
        <DashboardHeader title="Payments" />

        <div className="subscription-record outer-wrapper">
          {(data?.length !== 0 && userPlan.length == 0 && !isLoading) && (
          <div className="no-record row justify-content-center">
            <div className="col-12 text-center">
              <div className="no-record-wrapper d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
                <span>Upgrade to Gold to succeed in PTE</span>

                <NavLink
                  to="/admin/plans"
                  className="upgrade-btn text-white w-auto"
                >
                  <img src={starImg} alt="LA" /> Upgrade to Gold
                </NavLink>
              </div>
            </div>
          </div>
          )}
          <div className="table-wrapper">
            <Table>
              <thead>
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">Subscription</th>
                  <th className="text-center">Amount</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Next Billing / End Date</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  isLoading ? (
                    <tr>
                      <td colSpan={7}>
                        <Spinner />
                      </td>
                    </tr>
                  ) : data?.length === 0 ? (
                    <tr>
                      <td colSpan={7}>
                        <div className="table-heading visibility-visible no-record-wrapper">
                          <span className="no-record-found">
                            No subscription found
                          </span>

                          <NavLink to="/admin/plans" className="upgrade-btn text-white">
                            <img src={starImg} alt="LA" /> Upgrade to Gold
                          </NavLink>
                        </div>
                      </td>
                    </tr>
                  ) :
                    data && data.map((val, key) => {
                      return (
                        <tr className="visibility-visible" key={key}>
                          <td>{key + 1}</td>
                          <td className="text-center">{subscriptionTitle(val)}</td>
                          <td className="text-center">
                            <SubscriptionAmount
                              data={val}
                            />
                          </td>
                          <td className="text-center">
                            <SubscriptionStatus
                              subscription={val.subscription}
                            />
                          </td>
                          {/* <td>{recurringDate(val)}</td> */}
                          <td className="text-center">{expiryDate(val)}</td>
                          <td className="text-center">
                            <RowAction
                              subscription={val.subscription}
                            />
                          </td>
                        </tr>
                      )
                    })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Transaction;


/**
 * Subscription Amount.
 */
const SubscriptionAmount = ({
  data
}) => {


  const currency =
    data?.details !== null && data?.details?.currency
      ? data.details.currency.toUpperCase()
      : (data?.subscription?.plan?.price_in === data?.amount ? "INR" : "AUD");

  return (
    <>
      {currency} <b className="text-danger">{data.amount}</b>
    </>
  );
};


/**
 * Subscription Status.
 */
const SubscriptionStatus = ({
  subscription
}) => {

  let class_name = (subscription.status === 1) ? "success pl-3 pr-3" : "danger";
  let label = (subscription.status === 1) ? "Active" : "Inactive";

  return (
    <span className={`badge badge-${class_name}`}>{label}</span>
  );
};


/**
 * Row Action.
 */
const RowAction = ({
  subscription
}) => {

    const isExpired = () =>{
    const today = new Date().toISOString().split('T')[0];
    const expiryDate = subscription?.expiry_date;
       if (expiryDate === today) {
            store.dispatch(
              setAlert({ 
                flag: true, 
                type: 2, 
                message: "We're sorry, but subscription cancellations cannot be processed on the renewal date. Please contact our support team for assistance." 
              })
            );
            return true;
          }
    }
    
  return (
    <>
      {subscription?.status === 1 && subscription?.is_recurring_plan === 1 ? (
        <Link
          to="/admin/subscription-detail"
          className="outline-btn"
        >
          Cancel Subscription
        </Link>
      ) : subscription?.status === 1 && subscription?.is_canceled === 1 ? (
        <span className="text-danger">Cancelled</span>
      ) : (
        <span className="text-success"></span>
      )}
    </>
  );
};
